import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { Article } from '../entities/article';
import { catchError, Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: Article | Article[];
}

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private articleServiceUrl = this.apiServicesUrl + '/article';

  getAllArticles(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.articleServiceUrl)
      .pipe(
        catchError(this.handleError<ApiResponse>('getArticle'))
      );
  }

  getArticle(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.articleServiceUrl)
      .pipe(
        catchError(this.handleError<ApiResponse>('getArticle'))
      );
  }

  saveArticle(article: Article): Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    return this.http.post<ApiResponse>(this.articleServiceUrl, article, httpHeaders)
      .pipe(
        catchError(err => { return throwError(() => err) })
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }
}
